import React, {Component} from "react";
import Section from "./../layouts/Section";
import {Link} from "react-router-dom";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import {Alert} from "./../../alertServices";
import { database } from './firebase';
import moment from 'moment';
import GetLastMessage from './GetLastMessage';
import { withTranslation } from 'react-i18next';

var employees = {
  chatlist: []
};
var data = {
  chatlist: []
};

class Chat extends Component {
    constructor(props) {
        super(props);
        this.state={
          user_list:[],
          user_list2:[],
          group_list:[],
          total_record:'',
          group_id: '*',
          app_name:'',
        }
    }
    componentDidMount(){
        this.getUserChatList('*');
        this.getAllGroups();  
    }
    getUserChatList(groupId){
        var user_id= localStorage.getItem('userid');
        var formData = new FormData();
        formData.append("user_id",user_id);
        formData.append("group_id",groupId);
        post(Constent.GETUSERCHATLIST,formData).then(response=>{
          if(response.status){
            this.setState({user_list: response.data,
                total_record : response.data.length,
                app_name:response.app_name,
                group_id:groupId});
          }else{
            Alert.error({title: response.message});
          }
        })
    }
    getUserList(groupId){
        var user_id= localStorage.getItem('userid');
        var formData = new FormData();
        formData.append("user_id",user_id);
        formData.append("group_id",groupId);
        post(Constent.CONTACT,formData).then(response=>{
          if(response.status){
            this.setState({user_list2: response.user_list,
                total_record : response.user_list.length});
          }else{
            Alert.error({title: response.message});
          }
        })
    }

    getAllGroups(){
        var department_id= localStorage.getItem('department_id');
        var formData = new FormData();
        formData.append("department_id",department_id);
        post(Constent.GETALLGROUPS,formData).then(response=>{
          if(response.status){
            this.setState({group_list:response.data});
          }else{
            Alert.error({title: response.message});
          }
        })
    }

    selectDropdown = (val) => {
        this.getUserChatList(val);
    };

    newChat = (val) => {
        window['modalClose']();
        this.props.history.push(val);
    }
    render() {
        const { t } = this.props;
        return (
        <>    
            <div className="header-area timeregistraionpage" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-2 col-2">
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            </div>
                            <div className="col-sm-8 col-8 text-center">
                                <div className="page-name text-overflow">{t('lang.chat_sc_message')}</div>
                            </div>
                            <div className="col-sm-2 col-2 text-right pr-0"> 
                                <div className="menu-back-page"  onClick={()=>{ window.location.reload(false) }}>
                                    <i className="las la-sync" style={{fontSize: 20,marginTop: 6}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mg-top-50"></div>

                <div className="employeelistpage transaction-area pd-top-15 mg-bottom-40">
                    <select className="form-control" style={{background:'#E6E6E6',broder:'1px solid #CCCCCC',paddingLeft: 20}}
                    onChange={e => { this.selectDropdown(e.target.value)}}>
                    {this.state.group_list.map(({ id, group_name }) => (
                        <option value={id} key={id}>{(id === '*' ? t('lang.common_text_all_employees') : group_name ) }</option>
                    ))}
                    </select>
                    <ul className="transaction-inner" style={{marginTop:20}}>
                    <p className="text-center"> {this.state.user_list.length === 0 ? t('lang.chat_sc_start_your_first_chat') : ''}</p>
                    {this.state.user_list.map(({ id,chat_id, employee_id,job_title, first_name, last_name, profile_image,phone_no,last_message}) => (    
                        <GetLastMessage key={Math.random()} id={id} full_name={first_name +' '+last_name} chat_id={chat_id} app_name={this.state.app_name} profile_image={profile_image} />                       
                    ))}    
                    </ul>
                    
                </div>
                {/* transaction End */}
                
                <Link to={'#'} className="add-btn-right" 
                data-toggle="modal" data-target="#new-chat-modal" onClick={()=>{ this.getUserList(this.state.group_id) }}>
                    <i className="las la-sms"  style={{ fontSize: 30, padding: 10}}></i>
                </Link>

                {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                                <div className="col-8 offset-2">
                                    
                                </div>
                                <div className="col-2">
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-reply" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer End */}

               {/*  new-chat-modal start */}
            <div id="new-chat-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.chat_sc_new_chat')} (<span>{this.state.user_list2.length} {t('lang.chat_sc_employees')}</span>)</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                        {(this.state.user_list2.length > 0) ? '' : <p className="text-center">{t('lang.chat_sc_loading')}... </p> }
                            {this.state.user_list2.map(item=> (
                            <div key={Math.random()}  className="row" style={{background: '#FFFFFF', padding: 10,marginBottom: 5,textTransform: 'capitalize',fontSize: 20}}
                            onClick={e => { this.newChat('/chat/'+item.id)}} >
                            <div className="col-2" > 
                                  <img src={item.profile_image} alt="img" style={{borderRadius:'50%',height:30,width:30}} />
                            </div>
                            <label className="col-10" style={{marginBottom:0}}>{item.first_name} {item.last_name} </label>
                            
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div> 
            </>
        );
    }
}

export default withTranslation('common')(Chat);